<script>
import CustomCommonConfig from './CustomCommonConfig';
import validateFieldsMixin from '@/mixins/validateFields.mixin';

export default {
  extends: CustomCommonConfig,
  mixins: [validateFieldsMixin],
  emits: ['update:changeField'],
  data() {
    return {
      configTitle: this.$t('title.instanceMap'), // 위젯 config 타이틀
      defaultConfig: this.config({
        // 위젯 설정 정보
        isResizable: true,
        maxW: 8,
        maxH: 6,
        widget: {
          type: 'InstanceMapWidget',
          api: '/cloudmonitorings/product/v1/console/metric-data-latest',
          options: {}
        }
      }),
      validateFieldKey: 'instanceMapWidgetConfig'
    };
  },
  watch: {
    changedFieldData: {
      handler(value) {
        this.$emit('update:changeField', value);
      },
      immediate: true
    }
  },
  methods: {
    updateFieldsBeforeModify() {
      this.setFieldsBeforeModify();
    }
  }
};
</script>
<style lang="scss" scoped>
@import './styles/customCommonConfig.scss';
</style>
